import {
  Button,
  Stack,
  Tab,
  Tabs,
  Typography,
  Link,
  Chip,
  Radio,
  Box,
  createFilterOptions,
  Checkbox,
  TextField,
} from "@mui/material";
import {
  CustomTabPanel,
  CustomTable,
  CustomeDialog,
  DeleteModal,
  Loader,
  PageListLayout,
  InputControl,
  LimitedTag,
} from "../../../shared";
import { useMemo } from "react";
import AddIcon from "@mui/icons-material/Add";
import { useLocation, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useStores } from "../hooks";
import { createColumnHelper } from "@tanstack/react-table";
import { SubRowCustomTable } from "../components";
import { useFinishedProductsWithoutPLU } from "../hooks";

export const FinishedProductsWithoutPLU = () => {
  let { id } = useParams();
  let navigate = useNavigate();

  const {
    listQuery,
    tableData,
    state,
    categoryValuesHandler,
    CategoryOptions,
    onClearFilter,
    disableclearButton,
    selectStatus,
    onChangeStatusHandler,
    SubCategoryOptions,
    subCategoryValuesHandler,
  } = useFinishedProductsWithoutPLU(id);

  const { dataList, isLoading } = state;

  const filterOptions = createFilterOptions({
    matchFrom: "any",
    stringify: (option) => option.name,
  });

  const columnHelper = createColumnHelper();

  const columns = [
    columnHelper.accessor("name", {
      header: () => "Finished Product Name",
      cell: ({ getValue, row: { original } }) => (
        <Typography
          onClick={() =>
            navigate(`/recipe/details/${original?.id}?basic-details`)
          }
          variant="subtitle2"
          sx={{
            textDecoration: "underline",
            cursor: "pointer",
            color: "neutral.10",
          }}
        >
          {getValue()}
        </Typography>
      ),
    }),

    columnHelper.accessor("category", {
      header: () => "Category",
    }),

    columnHelper.accessor("subcategory", {
      header: () => "Sub-Category",
    }),

    columnHelper.accessor("status", {
      header: () => "Status",
      cell: ({ getValue }) => (
        <Chip
          size="small"
          color={getValue() === 1 ? "primary" : "gray"}
          variant="filled"
          label={getValue() === 1 ? "ACTIVE" : "INACTIVE"}
        />
      ),
    }),

    columnHelper.accessor("cost_exc_gst", {
      header: () => "Cost (Ex GST)",
      cell: ({ getValue }) => `$${getValue().toFixed(3)}`,
    }),
  ];

  return (
    <>
      <CustomTable
        defaultData={dataList}
        columns={columns}
        // isPagination={false}
        headerText="Finished Products (Without PLU)"
        showSearchBar={true}
        isLoading={listQuery?.isLoading}
        emptyTableMessage={"No finished products without PLU assigned"}
        tableHeaderStyles={{ fontSize: "18px", fontWeight: 600 }}
        enableTableContainerPaddingBottom
        tableHeaderContent={
          <Stack
            sx={{
              flexDirection: "row",
              gap: "6px",
              width: "100%",
            }}
          >
            <InputControl
              type="dropdown"
              variant="filter"
              size="small"
              fullWidth
              multiple={true}
              options={CategoryOptions ?? []}
              getOptionLabel={(option) => option?.name || ""}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              disableCloseOnSelect
              sx={{
                width: "250px",
              }}
              renderTags={(value) => (
                <LimitedTag value={value} autocompleteWidth="250px" />
              )}
              value={
                tableData?.finishedProductsWithoutPlu?.data?.categoryfilter ??
                []
              }
              onChange={(event, option) => categoryValuesHandler(event, option)}
              renderOption={(props, option, { selected }) => (
                <>
                  <li {...props} key={option.id}>
                    <Checkbox style={{ marginRight: 8 }} checked={selected} />
                    {option?.name}
                  </li>
                </>
              )}
              filterOptions={filterOptions}
              renderInput={(params) => (
                <TextField {...params} placeholder="Category" />
              )}
            />
            <InputControl
              type="dropdown"
              variant="filter"
              size="small"
              fullWidth
              multiple={true}
              options={SubCategoryOptions ?? []}
              getOptionLabel={(option) => option?.name || ""}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              disableCloseOnSelect
              sx={{
                width: "250px",
              }}
              renderTags={(value) => (
                <LimitedTag value={value} autocompleteWidth="250px" />
              )}
              value={
                tableData?.finishedProductsWithoutPlu?.data
                  ?.subcategoryfilter ?? []
              }
              onChange={(event, option) =>
                subCategoryValuesHandler(event, option)
              }
              renderOption={(props, option, { selected }) => (
                <>
                  <li {...props} key={option.id}>
                    <Checkbox style={{ marginRight: 8 }} checked={selected} />
                    {option?.name}
                  </li>
                </>
              )}
              filterOptions={filterOptions}
              renderInput={(params) => (
                <TextField {...params} placeholder="Sub-Category" />
              )}
            />
            <InputControl
              type="dropdown"
              variant="filter"
              size="small"
              options={selectStatus.statusOptions}
              getOptionLabel={(option) => option?.name || ""}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              sx={{
                width: "180px",
              }}
              value={
                selectStatus?.statusOptions?.find(
                  (option) =>
                    option.id ===
                    tableData.finishedProductsWithoutPlu.data.selectedStatus,
                ) || null
              }
              renderInput={(params) => (
                <TextField {...params} placeholder="Status" />
              )}
              onChange={(event, option) =>
                selectStatus.statusValueChangeHandler(option)
              }
            />
            <Button
              type="button"
              size="small"
              variant="text"
              sx={{
                p: "6px 12px 6px 12px",
                gap: "6px",
              }}
              disabled={disableclearButton}
              onClick={onClearFilter}
            >
              Clear All
            </Button>
          </Stack>
        }
      />
    </>
  );
};
